import App from '../App/App.js';
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {Power4} from "gsap/gsap-core";
import Section from "../Sections/Section";
import Page from "../Layout/Page/Page";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin, Power4);

const Scroller = {
    selected: "",
    trashHold: 5,
    changeUrlOnAnchors: false,
    animTime: 0.5,
    yOffset: 86,
    loadingDelay: 500,

    init(collection) {

        collection = collection ? collection : $('body');

        if (App.debug) {
            console.log("Scroller.init()  ---------------------");
            console.log(collection);
        }

        this.sections = $('[component="Page"] section[id]');
        this.initScrollToAnchor();
        Page.init();
        Section.init();
        if (App.isIphone || window.killSmoothScroller) return;
        // this.InitSmoother();

    },

    InitSmoother() {
        this.smoother = ScrollSmoHother.create({
            smooth: 0.5,
            effects: true,
            smoothTouch: 0.1,
            normalizeScroll: false,
        });
    },

    initScrollToAnchor() {

        const anchor = $('[method="renderMenu"]').find('a[href*="#"]');

        anchor.click((evt) => {
            const el = $(evt.currentTarget);
            const anchorUrl = el.attr('href').split('#')[0].substring(1);
            const currentUrl = $('[component="Page"]').attr('url');
            if(anchorUrl !== currentUrl) return true;

            evt.preventDefault();
            const url = el.attr('href').split('#').pop();
            this.scrollToAnchor($('#' + url))
        })

        if (!this.sections) return;
        const section = $(window.location.hash);
        if (!section.length) return;

        this.scrollToAnchor(section);
    },

    scrollToAnchor(section) {

        const hasSubmenu = $('[component="Header"] .dropdown').length > 0;
        const offset = hasSubmenu ? 24: 0

        setTimeout(() => {
            gsap.to(window, {
                duration: Scroller.animTime, scrollTo: {y: section, offsetY: Scroller.yOffset + offset}
            });
        }, Scroller.loadingDelay)

    },

    goTop() {
        // ak nepouzivam JS scrollbar
        // $('[component="Page"]').animate({ "scrollTop": 0 }, 700, "easeInOutQuint", function() {
        $('html, body').animate({"scrollTop": 0}, 700, "easeInOutQuint", function () {
            Scroller.isScrolling = false;
        });
    },
}

export default Scroller;